import { Command, MergeDBUpdates } from "mobx-firelink";
import { GetUserExtraInfo } from "Store/firebase/users";
/*export function MapEdit(targetClass: Function);
export function MapEdit(mapIDKey: string);
export function MapEdit(...args) {
    let mapIDKey = "mapID";
    if (IsFunction(args[0])) {
        ApplyToClass(args[0]);
    } else {
        mapIDKey = args[0];
        return ApplyToClass;
    }

    function ApplyToClass(targetClass: Function) {
        /* if (targetClass.prototype instanceof Command_Old) {
            const oldPrepare = targetClass.prototype.Prepare;
            targetClass.prototype.Prepare = async function () {
                await oldPrepare.apply(this);
                const mapID = this.payload[mapIDKey];
                if (mapID) {
                    this.map_oldEditCount = (await GetAsync(() => GetMap(mapID)))?.edits ?? 0;
                }
            };
        } *#/

        if (targetClass.prototype instanceof Command) {
            const oldValidate = targetClass.prototype.Validate;
            targetClass.prototype.Validate = function() {
                const result = oldValidate.apply(this);
                const mapID = this.payload[mapIDKey];
                if (mapID) {
                    const map = GetMap(mapID);
                    if (map != null) {
                        this.map_oldEditCount = map.edits ?? 0;
                    }
                }
                return result;
            };
        }

        const oldGetDBUpdates = targetClass.prototype.GetDBUpdates;
        targetClass.prototype.GetDBUpdates = function() {
            const updates = oldGetDBUpdates.apply(this);
            const newUpdates = {};
            if (this.map_oldEditCount != null) {
                const mapID = this.payload[mapIDKey];
                if (mapID) {
                    newUpdates[`maps/${mapID}/.edits`] = this.map_oldEditCount + 1;
                    newUpdates[`maps/${mapID}/.editedAt`] = Date.now();
                }
            }
            return MergeDBUpdates(updates, newUpdates);
        };
    }
}*/
export function UserEdit(targetClass) {
    /* if (targetClass.prototype instanceof Command_Old) {
        const oldPrepare = targetClass.prototype.Prepare;
        targetClass.prototype.Prepare = async function () {
            await oldPrepare.apply(this);
            this.user_oldEditCount = (await GetAsync(() => GetUserExtraInfo(this.userInfo.id)))?.edits ?? 0;
        };
    } */
    if (targetClass.prototype instanceof Command) {
        const oldValidate = targetClass.prototype.Validate;
        targetClass.prototype.Validate = function () {
            const result = oldValidate.apply(this);
            const userExtraInfo = GetUserExtraInfo(this.userInfo.id);
            if (userExtraInfo) {
                this.user_oldEditCount = userExtraInfo.edits ?? 0;
            }
            return result;
        };
    }
    const oldGetDBUpdates = targetClass.prototype.GetDBUpdates;
    targetClass.prototype.GetDBUpdates = function () {
        const updates = oldGetDBUpdates.apply(this);
        const newUpdates = {};
        if (this.user_oldEditCount != null) {
            newUpdates[`userExtras/${this.userInfo.id}/.edits`] = this.user_oldEditCount + 1;
            newUpdates[`userExtras/${this.userInfo.id}/.lastEditAt`] = Date.now();
        }
        return MergeDBUpdates(updates, newUpdates);
    };
}
// this should almost always be the bottom (last line) decorator, so that it's applied first and doesn't capture extra-updates from other decorators
export function UndoableAction() {
    return function (targetClass) {
        // todo: reimplement
        /*if (targetClass.prototype instanceof Command) {
            const oldValidate = targetClass.prototype.Validate;
            targetClass.prototype.Validate = function() {
                const result = oldValidate.apply(this);
                
                //let updates = this.GetDBUpdates();
                const updates = oldGetDBUpdates.call(this);
                this.updates_oldData = {};
                for (const {name: path, value: newData} of updates.Props()) {
                    const oldData = Get({addHelpers: false}, ...path.split("/"));
                    this.updates_oldData[path] = oldData;
                }

                this.user_oldActionCount = ToInt(await GetDataAsync({addHelpers: false}, "userExtras", this.userInfo.id, ".actions")) || 0;

                this.undoneActions = (await GetAsync(()=>GetRecentActions(this.userInfo.id))).filter(a=>a.undone);

                return result;
            };
        }

        let oldGetDBUpdates = targetClass.prototype.GetDBUpdates;
        targetClass.prototype.GetDBUpdates = function() {
            const updates = oldGetDBUpdates.apply(this);

            const newUpdates = {};
            newUpdates[`userExtras/${this.userInfo.id}/.actions`] = this.user_oldActionCount + 1;

            const actionID = this.user_oldActionCount;
            newUpdates[`userExtras/${this.userInfo.id}/recentActions/${actionID}`] = {oldData: this.updates_oldData, newData: updates};
            // trim recent-actions list so it doesn't grow more than 30 entries long
            newUpdates[`userExtras/${this.userInfo.id}/recentActions/${actionID - 30}`] = null;

            // for any recent-action that has been undone, delete it from history now that we're adding a new entry (we moved before the entries, then added new, making them outdated)
            for (const action of this.undoneActions) {
                newUpdates[`userExtras/${this.userInfo.id}/recentActions/${action._id}`] = null;
            }

            return MergeDBUpdates(updates, newUpdates);
        };*/
    };
}
